var reDoubleSlash = /([^:])\/\//g; // matches // anywhere but in the protocol

var reParent = /[-\w]+\/\.\.\//; // matches a foo/../ expression

var reProtocol = /^(http||https):\/\//;
/**
 * Resolves a relative URL into an absolute URL.
 */

export default function resolveUrl(value) {
  var url = value; // replace all // except the one in proto with /

  url = url.replace(reDoubleSlash, '$1/'); // If the url is a valid url we do nothing

  if (!reProtocol.exec(url)) {
    // If this is a relative path
    var path = url.substring(0, 1) === '/' ? '' : window.location.pathname;

    if (path.substring(path.length - 1) !== '/') {
      path = path.substring(0, path.lastIndexOf('/') + 1);
    }

    url = "".concat(window.location.protocol, "//").concat(window.location.host).concat(path).concat(url);
  } // reduce all 'xyz/../' to just ''


  while (reParent.test(url)) {
    url = url.replace(reParent, '');
  }

  return url;
}


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/postmessage/lib/esm/resolveUrl.js
// module id = 652
// module chunks = 0 1